// extracted by mini-css-extract-plugin
module.exports = {"item":"N_dh","item__image":"N_dj"};